import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Button, Input } from 'antd'

export const TimeLineContentWrapper = styled.div`
  box-shadow: 0 2px 4px 0 #cacaca80;
  padding: 5px 10px;
  border-radius: 5px;
  background-color: ${props => (props.color ? props.color : '#fdfdfd')};
  display: flex;
  margin-right: 3px;
  position: relative;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

  @media (max-width: 768px) {
    padding: 8px 12px;
    margin-right: 0;
    width: 100%;
    max-width: 100%;
    font-size: 14px;

    .ant-space {
      flex-wrap: wrap;
      width: 100%;
    }

    .ant-space-item {
      margin-bottom: 4px;
    }

    .ant-btn {
      font-size: 12px;
      padding: 4px 8px;
      height: auto;
    }

    .ant-tooltip {
      font-size: 12px;
    }
  }
`

/** Карточка «История»: при наведении показывает кнопку `.timeline-info-edit` */
export const TimelineInfoCard = styled(TimeLineContentWrapper)`
  &:hover .timeline-info-edit {
    opacity: 1;
  }
`

export const TimelineInfoEditIcon = styled.button.attrs({ type: 'button' })`
  position: absolute;
  right: 4px;
  bottom: 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, color 0.15s ease, background-color 0.15s ease;
  z-index: 1;

  &:hover {
    color: var(--system-focus, #1677ff);
    background-color: var(--system-primary-subtle, rgba(22, 119, 255, 0.08));
  }

  &:focus-visible {
    opacity: 1;
    outline: 2px solid var(--system-focus, #1677ff);
    outline-offset: 1px;
  }
`

export const TimeLineContentHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    .ant-space {
      width: 100%;
      justify-content: flex-start;
    }
  }
`
export const TimeLineContentHeaderType = styled.div`
  font-size: 14px;
  color: white;
  font-weight: bold;
  background-color: blue;
  padding: 0 12px;
  border-radius: 9px;
`
// export const DotStyle = styled.div`
//   font-size: 16px;
//   padding: 7px;
//   border-radius: 50%;
//   background-color: darkgray;
//   color: #fff;
//   background-color: ${props => props.color};
// `
export const AvitoStyle = styled.div`
  padding: 2px;
  border-radius: 50%;
  background-color: white;
  border: 1px solid #2fc4f5;
  width: 33px;
  height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const ShowWrapper = styled.button`
  border-radius: 50%;
  padding: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #f0f0f0;
  svg {
    transform: rotate(${props => props.color}deg);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
`
export const LinkButton = styled(Link)`
  display: inline-block;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  white-space: nowrap;
  transition: color 1s cubic-bezier(0.645, 0.045, 0.355, 1);
  &:hover {
    color: #40a9ff;
  }
`

export const NotLinkButton = styled.span`
  display: inline-block;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  white-space: nowrap;
  transition: color 1s cubic-bezier(0.645, 0.045, 0.355, 1);
  &:hover {
    color: #40a9ff;
  }
`

export interface IStyledPropsStage {
  color?: string
  fontWeight?: string
  fontColor?: string
}

// export const Stage = styled.span<IStyledPropsStage>`
//     display: inline-block;
//     overflow: hidden;
//     padding: 0 12px;
//     border-radius: 9px;
//     background-color: ${props => props.color ? props.color: '#e8f1fb'};
//     color: ${props => props.fontColor ? props.fontColor: '#333'};
//     font-weight: ${props => props.fontWeight ? props.fontWeight: 'unset'};
//     vertical-align: middle;
//     text-overflow: ellipsis;
//     white-space: nowrap;
//     margin-bottom: 4px;
// `

export const NoteEditButton = styled(Button)`
  background-color: unset !important;
  font-size: 14px;
  padding: 0;
  height: min-content;
  border: none;
  &:hover {
    color: #40a9ff;
  }
`

export const NoteTextArea = styled(Input.TextArea)`
  width: 100%;
  height: 100%;
`

export const NoteSaveButton = styled(Button)`
  background-color: #97c807;
  margin-top: 10px;
  margin-bottom: 5px;
  width: min-content;
  color: #fff;
  &:hover {
    color: #fff;
    background-color: #97c807;
  }
`

export const TaskButtonCloseWrapper = styled.div`
  height: min-content;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  button {
    width: max-content;
  }

  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 8px;

    button {
      width: 100%;
      max-width: 200px;
    }
  }
`
